export * from './types';
export { WebPurchaseStrategy } from './WebPurchaseStrategy';
export { NativePurchaseStrategy } from './NativePurchaseStrategy';
export { PurchaseStrategyFactory } from './PurchaseStrategyFactory';

// Convenience exports for the main functionality
import { PurchaseStrategyFactory } from './PurchaseStrategyFactory';
export const initializeRevenueCat = PurchaseStrategyFactory.initializeStrategy;
export const getPurchaseStrategy = PurchaseStrategyFactory.getInstance; 